<div class="container my-10 md:my-20">
  <div class="grid md:grid-cols-2 items-center gap-x-8 gap-y-4">
    <div class="video bg-amber-700 rounded-2xl overflow-hidden aspect-video" [class]="reversed()?'order-2':'order-1'">
      <video class="w-full h-full object-cover" controls muted>
        <source src="https://www.youtube.com/watch?v=dQw4w9WgXcQ" type="video/mp4" />
      </video>
    </div>
    <div class="grid grid-cols-1 grid-rows-3">
      <h2 class="block mb-2 text-4xl font-medium row-span-1">About Our Team</h2>
      <p class="text-primary-500 text-xl row-span-1">
        A creative, tech-driven team turning ideas into real digital experiences.
      </p>
      <p class="text-gray-600 row-span-1">
        We’re a team of designers, developers, and strategists passionate about solving problems with smart, scalable
        tech. From startups to enterprise clients, we work closely with you to build digital solutions that actually
        work — and feel good to use.
      </p>
    </div>
  </div>
</div>